import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiUrlsEnum } from '../enums';
import { IFileDownload } from '../interfaces';

@Injectable()
export class FileTransferService {

  constructor(
    protected readonly http: HttpClient,
  ) {}

  public fileUpload(file: File, uri: any): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<any>(`${environment.host}${uri}`, formData);
  }

  public downloadFile(uri: ApiUrlsEnum): Observable<IFileDownload> {
    return this.http.get(`${environment.host}${uri}`, { responseType: 'blob', observe: 'response' })
      .pipe(
        map((resp: HttpResponse<File>) => {
          const header = resp.headers.get('content-disposition').split(';')[1];
          const filename = header.split('=')[1];
          return {
            blob: resp.body,
            filename,
          };
        }),
      );
  }
}
